import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatDate, toDate } from "../../../utils/toDate";

import printIcon from "../../../assets/printer_icon.png";
import editIcon from "../../../assets/edit_icon.png";
import saveIcon from "../../../assets/save_icon.png";
import closeIcon from "../../../assets/close_icon.png"

import CustomButton from "../../../components/CustomButton";
import Modal from "../../../components/Modal";
import InformationDiv from "../../merchant-pages/invoicesOfMulti/InformationDiv";
import SectionDivider from "../../../components/SectionDivider";
import InformationBox from "../../../components/InformationBox";
import PDFUploader from "../../../components/PDFUploader";
import EditNoCustomerInvoice from "./EditNoCustomerInvoice";
import classes from "../../../components/Modal.module.css";
import CustomInput from "../../../components/CustomInput";
import Dropdown from "../../../components/Dropdown";
import axios from "axios";

export default function ContainerInformationModal({
  containerInfo: defaultContainerInfo,
  subCompanyInfo,
  handleClose,
  invoice,
  setInvoice,
  handleConfirmEdit,
}) {
  const { t } = useTranslation("general");
  const [isEdit, setIsEdit] = useState(false);
  const printRef = useRef(null);
  const pdfUploaderRef = useRef(null);
  const [containerInfo, setContainerInfo] = useState(defaultContainerInfo);
  const [error, setError] = useState("");
  const [loadingModal, setLoadingModal] = useState(false);

  const handlePrint = () => window.print();

  const handleInputChange = (e, containerIndex = null, type) => {
    const { name, value } = e.target;

    setContainerInfo((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const handleSaveContainer = () => {
    const newInvoice = {
      ...invoice,
      ShippedContainer: invoice?.ShippedContainer.map((container) => {
        return container.id === containerInfo.id
          ? {
              ...containerInfo,
              oldContainerNumber: defaultContainerInfo.containerNumber,
            }
          : container;
      }),
    };

    handleClose();
    setInvoice(newInvoice);
    handleConfirmEdit(newInvoice);
  };

  // TODO: handle it here so we can show error and loading
  // const handleConfirmEdit = async (invoice) => {
  //   const token = localStorage.getItem("token");
  //   const userId = parseInt(localStorage.getItem("userId"), 10);
  //   const organizationId = parseInt(localStorage.getItem("organizationId"), 10);
  //   const newInvoice = invoice;

  //   try {
  //     setLoadingModal(true);
  //     // Send a PUT request to the backend to update the invoice with the existing data
  //     const editedInvoice = await axios.put(
  //       `${process.env.REACT_APP_URL}/updateInvoiceOfMultiContsWithoutC/${invoice?.id}`,
  //       {
  //         ...newInvoice,
  //         organizationId,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "User-Id": userId,
  //           "Supplier-Id": invoice?.supplierId,
  //           // "Organization-Id": organizationId,
  //         },
  //       }
  //     );

  //     const { status, error } = editedInvoice;
  //     if (editedInvoice?.status === 200) {
  //       setInvoice((prev) => {
  //         return { ...prev, ...editedInvoice?.data?.invoice };
  //       });
  //       setError("");
  //     }

  //     // await handleChildUploadDocs(editedInvoice?.data?.invoice?.id);
  //     setIsEdit(false);
  //   } catch (error) {
  //     // setError(errorMsg || "Error updating invoice.");
  //     const errMsg = error.response?.data?.message;
  //     if (errMsg === "alreadyLinkedToAnInvoice") {
  //       const containerNumber = error?.response?.data?.containerNumber;
  //       setError(`${t("container")} ${containerNumber} ${t(errMsg)}`);
  //     } else {
  //       setError(errMsg || "An error occurred");
  //     }

  //     // Log and display any errors that occur during the update process
  //     console.error("Error updating invoice:", error);
  //   } finally {
  //     // window.scrollTo(0, 0);
  //     setLoadingModal(false);
  //   }
  // };

  return (
    <Modal
      title={t("containerDetails")}
      onClose={handleClose}
      footer={
        <section className="o-row o-row--gap-size_300 o-row--horizontal-align_end">
          {isEdit ? (
            <>
              <CustomButton
                variant="blank"
                elementType={Link}
                title={t("cancel")}
                icon={closeIcon}
                iconSize={18}
                onClick={handleClose}
                type="button"
              />
              <CustomButton
                elementType={Link}
                title={t("save")}
                icon={saveIcon}
                iconSize={18}
                onClick={handleSaveContainer}
                type="button"
              />
            </>
          ) : (
            <>
              <CustomButton
                title={t("print")}
                variant="gray"
                icon={printIcon}
                iconSize={18}
                onClick={handlePrint}
              />
              <CustomButton
                variant="blank"
                elementType={Link}
                title={t("edit")}
                icon={editIcon}
                iconSize={18}
                onClick={() => setIsEdit(true)}
              />
            </>
          )}
        </section>
      }
    >
      {isEdit ? (
        <>
          <div className={classes.inputContainer}>
            <span>{t("containerNumber")}: </span>
            <div className={classes.invoiceNumberContainer}>
              <CustomInput
                name="containerNumber"
                value={containerInfo?.containerNumber}
                onChange={(e) => handleInputChange(e, 0)}
                flex
              />
            </div>
          </div>

          <div className={classes.inputContainer}>
            <span>{t("expectedArrivalDate")}: </span>
            <CustomInput
              name="expectedArrivalDate"
              type="date"
              value={formatDate(containerInfo?.expectedArrivalDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
              flex
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("finalDestination")}: </span>
            <CustomInput
              name="finalDestination"
              value={containerInfo?.finalDestination}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("material")}: </span>
            <CustomInput
              name="material"
              value={containerInfo?.material}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("numberOfBoxes")}: </span>
            <CustomInput
              name="numberOfBoxes"
              value={containerInfo?.numberOfBoxes}
              onChange={(e) => handleInputChange(e, 0)}
              type="moneyV2"
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("measuringUnit")}: </span>
            <CustomInput
              name="measuringUnit"
              value={containerInfo?.measuringUnit}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("shipper")}: </span>
            <CustomInput
              name="shipper"
              value={containerInfo?.shipper}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("dateOfEntry")}: </span>
            <CustomInput
              name="dateOfEntry"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.dateOfEntry)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("shippingDate")}: </span>
            <CustomInput
              name="shippingDate"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.shippingDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("exitDate")}: </span>
            <CustomInput
              name="exitDate"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.exitDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          {/* Permits Receiving Date */}
          <div className={classes.inputContainer}>
            <span>{t("permitsReceivingDate")}: </span>
            <CustomInput
              name="permitsReceivingDate"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.permitsReceivingDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          {/* Delivered or NOT delivered */}
          <div className={classes.inputContainer}>
            <span>{t("deliveryStatus")}: </span>
            <Dropdown
              options={[
                { title: "delivered", value: true },
                {
                  title: "notDelivered",
                  value: false,
                },
              ]}
              selected={
                containerInfo?.delivered
                  ? {
                      title: "delivered",
                      value: true,
                    }
                  : {
                      title: "notDelivered",
                      value: false,
                    }
              }
              setSelected={(status) => {
                handleInputChange(
                  {
                    target: {
                      name: "delivered",
                      value: status?.value,
                    },
                  },
                  0
                );
              }}
              flex
            />
          </div>

          {/* Notes */}
          <div className={classes.inputContainer}>
            <span className={classes.notesClass}>{t("notes")}: </span>
            <CustomInput
              name="notes"
              type="textarea"
              value={containerInfo?.notes || ""}
              onChange={(e) => handleInputChange()}
              flex={true}
            />
          </div>
          <div className="o-row o-row--horizontal-align_end">
            {/* <button
              onClick={() => handleAttemptDelete()}
              className="temp-delete-button"
              type="button"
            >
              ❌ {t("delete")}
            </button> */}
          </div>
        </>
      ) : (
        <div className="printing-area" ref={printRef}>
          <InformationDiv
            title="containerNumber"
            value={containerInfo?.containerNumber}
          />
          <InformationDiv
            title="expectedArrivalDate"
            value={toDate(containerInfo?.expectedArrivalDate)}
          />
          <InformationDiv
            title="finalDestination"
            value={containerInfo?.finalDestination}
          />
          <InformationDiv title="material" value={containerInfo?.material} />
          <div className="o-row o-row--vertical-align_center o-row--gap-size_600 u-margin--bottom_300">
            <div className="o-row o-row--vertical-align_center o-row--horizontal-align_space-between u-width_full-width u-max-width_200">
              <span className="t-bold_semi-bold t-text-medium ">
                {t("numberOfBoxes")}:
              </span>
              <span>{containerInfo?.numberOfBoxes}</span>
            </div>

            <div className="o-row o-row--vertical-align_center o-row--horizontal-align_space-between o-row--gap-size_300 u-max-width_200">
              <span className="t-bold_semi-bold t-text-medium">
                {t("measuringUnit")}:
              </span>
              <span>{containerInfo?.measuringUnit}</span>
            </div>
          </div>
          {/* <InformationDiv title="unitPrice" value={containerInfo?.unitPrice} /> */}
          <InformationDiv title="shipper" value={containerInfo?.shipper} />
          <InformationDiv
            title="shippingDate"
            value={toDate(containerInfo?.shippingDate)}
          />
          <InformationDiv title="company" value={subCompanyInfo?.nameInAr} />
          <InformationDiv
            title="exitDate"
            value={toDate(containerInfo?.exitDate)}
          />

          <InformationDiv
            title="dateOfEntry"
            value={toDate(containerInfo?.dateOfEntry)}
          />

          <InformationDiv
            title="permitsReceivingDate"
            value={toDate(containerInfo?.permitsReceivingDate)}
          />
          <InformationDiv title="notes" value={containerInfo?.notes} />
          <InformationDiv
            title="deliveryStatus"
            value={
              containerInfo?.delivered ? t("delivered") : t("notDelivered")
            }
          />
          <PDFUploader
            ref={pdfUploaderRef}
            invoiceDocs={containerInfo.document}
            mode={"show"}
            documents={containerInfo.document}
            title="containerDocuments"
          />
        </div>
      )}
    </Modal>
  );
}
